import { FC, ReactElement, useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { Style } from '@capacitor/status-bar';

import { NativePageBackground } from '../../atoms/NativePageBackground/NativePageBackground';
import { BottomSlider } from '../../molecules/BottomSlider/BottomSlider';
import { useStatusBarStyleSync } from '../../organisms/StatusBarStyleSyncProvider/context';

import {
	ContentBlock,
	FooterBlock,
	HeaderBlock,
	Root,
} from './DriverHome.styles';

export interface DriverHomeProps {
	webHeaderComponent?: ReactElement;
	headerComponent: ReactElement;
	contentComponent: ReactElement;
	footerComponent?: ReactElement;
	sliderContent: ReactElement;
	navigationComponent?: ReactElement;
	sliderIsOpen: boolean;
	withTransparency: boolean;
}

export const DriverHomeLayout: FC<DriverHomeProps> = ({
	webHeaderComponent,
	headerComponent,
	contentComponent,
	footerComponent,
	navigationComponent,
	sliderContent,
	sliderIsOpen,
	withTransparency,
}) => {
	const [layoutIsHidden, setLayoutIsHidden] = useState(false);

	const { replace } = useStatusBarStyleSync();

	useEffect(() => {
		replace({
			title: 'DriverHomeLayout',
			style: Style.Light,
		});
	}, [replace]);

	useEffect(() => {
		let tId: NodeJS.Timeout | null = null;

		if (sliderIsOpen === true && withTransparency) {
			if (!tId) {
				tId = setTimeout(() => {
					setLayoutIsHidden(true);
				}, 300);
			}
		}

		if (sliderIsOpen === false) {
			setLayoutIsHidden(false);
		}

		return () => {
			if (tId) {
				clearTimeout(tId);
			}
		};
	}, [sliderIsOpen, withTransparency]);

	return (
		<Root
			hidden={layoutIsHidden}
			isNativePlatform={Capacitor.isNativePlatform()}
		>
			{webHeaderComponent}
			<HeaderBlock>{headerComponent}</HeaderBlock>
			<ContentBlock>{contentComponent}</ContentBlock>
			<FooterBlock>{footerComponent}</FooterBlock>
			<BottomSlider open={sliderIsOpen} withHeader={false}>
				{sliderContent}
			</BottomSlider>
			{navigationComponent}
			{!layoutIsHidden && <NativePageBackground bgColor="white" />}
		</Root>
	);
};

export default DriverHomeLayout;
